import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  public async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const url: string = state.url;
    return await this.checkLogin(url);
  }

  private async checkLogin(url: string): Promise<boolean> {
    await this.auth.checkToken();

    //console.log('checking route', url, this.auth.isAuthenticated());
    if (this.auth.isAuthenticated()) { return true; }

    // Store the attempted URL for redirecting
    this.auth.redirectUrl = url;

    // Navigate to the login page with extras
    this.auth.logout();
    return false;
  }

}
